// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_2JaeQ{position:fixed;visibility:hidden;transition-property:visibility;touch-action:pan-y;z-index:900}.container_2JaeQ,.scrim_arQ0L{top:0;bottom:0;right:0;left:0}.scrim_arQ0L{transition-property:opacity;transform:translateZ(0);opacity:0;background:rgba(0,0,0,.5)}.content_3vQtl,.scrim_arQ0L{position:absolute}.content_3vQtl{top:0;bottom:0;left:0;width:256px;transition-property:transform;transform:translate3d(-100%,0,0);background-color:#fff}", ""]);
// Exports
exports.locals = {
	"container": "container_2JaeQ",
	"scrim": "scrim_arQ0L",
	"content": "content_3vQtl"
};
module.exports = exports;
